import ChainsCategories from './ChainsCategories';
import './ChainsCategories.scss';

export default ChainsCategories;
